// extracted by mini-css-extract-plugin
module.exports = {"container":"BannerHTML5_container__ZikN2","text":"BannerHTML5_text__n83zj","button":"BannerHTML5_button__XChRg","a":"BannerHTML5_a__VRQnJ"};